/**
 * Hide Buy with Prime button when subscription is selected on PDP.
 * Hooks into existing native `change` on input[name="selling_plan_type"].
 */
(function () {
  function applyBwpVisibility(section) {
    const container =
      section.querySelector('[data-bwp-container]') ||
      section.querySelector('delivery-promise-wc') ||
      section.querySelector('.delivery-promise__promise-container');
    if (!container) return;

    const purchaseOptions = section.querySelector('product-purchase-options');
    const checked = section.querySelector('input[name="selling_plan_type"]:checked');
    const isSubscription = checked && checked.value === 'subscription';

    if (!purchaseOptions) {
      container.removeAttribute('hidden');
      return;
    }
    if (isSubscription) {
      container.setAttribute('hidden', '');
    } else {
      container.removeAttribute('hidden');
    }
  }

  function init(section) {
    if (!section) return;
    applyBwpVisibility(section);

    section.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[name="selling_plan_type"]')) {
        applyBwpVisibility(section);
      }
    });

    const bwpContainer = section.querySelector('[data-bwp-container]');
    if (bwpContainer) {
      const observer = new MutationObserver(function () {
        applyBwpVisibility(section);
      });
      observer.observe(bwpContainer, { childList: true, subtree: true });
    }
  }

  function run() {
    const section = document.querySelector('.product-information');
    init(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
